// officeMember.actions.js
import axiosInstance from "../helpers/axios";
import { officeMemberConstants as C } from "./constants";

const getError = (error, fallback = "Ошибка запроса") => {
    return error?.response?.data?.message ||
        error?.response?.data?.error ||
        error?.message ||
        fallback;
};

export const clearOfficeMembersError = () => ({
    type: C.CLEAR_OFFICE_MEMBERS_ERROR,
});

export const getOfficeMembers = (officeId) => {
    return async (dispatch) => {
        try {
            if (!officeId || officeId === "all") {
                dispatch({
                    type: C.GET_OFFICE_MEMBERS_FAILURE,
                    payload: { error: "Выберите конкретный офис" },
                });

                return null;
            }

            dispatch({ type: C.GET_OFFICE_MEMBERS_REQUEST });

            const response = await axiosInstance.get(`/office/${officeId}/members`);

            dispatch({
                type: C.GET_OFFICE_MEMBERS_SUCCESS,
                payload: {
                    officeId,
                    members: response.data?.members || [],
                    currentMember: response.data?.currentMember || null,
                    permissions: response.data?.permissions || {},
                    roles: response.data?.roles || [],
                },
            });

            return response.data;
        } catch (error) {
            dispatch({
                type: C.GET_OFFICE_MEMBERS_FAILURE,
                payload: { error: getError(error, "Ошибка загрузки сотрудников") },
            });

            return null;
        }
    };
};

// Silent batch refresh: keeps loading/error state and the rest of the roster intact.
export const getOfficeMemberPresence = (officeId) => async () => {
    if (!officeId || officeId === 'all') return null;

    const response = await axiosInstance.get(`/office/${officeId}/members`, {
        params: { presenceOnly: 'true' },
    });

    return response.data?.presenceByUserId || null;
};

export const addOfficeMember = (officeId, payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: C.ADD_OFFICE_MEMBER_REQUEST });

            const response = await axiosInstance.post(`/office/${officeId}/members`, payload);

            dispatch({
                type: C.ADD_OFFICE_MEMBER_SUCCESS,
                payload: {
                    officeId,
                    member: response.data?.member,
                },
            });

            return response.data;
        } catch (error) {
            dispatch({
                type: C.ADD_OFFICE_MEMBER_FAILURE,
                payload: { error: getError(error, "Ошибка добавления сотрудника") },
            });

            throw error;
        }
    };
};

export const updateOfficeMember = (officeId, memberId, payload) => {
    return async (dispatch) => {
        try {
            dispatch({ type: C.UPDATE_OFFICE_MEMBER_REQUEST });

            const response = await axiosInstance.patch(`/office/${officeId}/members/${memberId}`, payload);

            dispatch({
                type: C.UPDATE_OFFICE_MEMBER_SUCCESS,
                payload: {
                    officeId,
                    member: response.data?.member,
                },
            });

            return response.data;
        } catch (error) {
            dispatch({
                type: C.UPDATE_OFFICE_MEMBER_FAILURE,
                payload: { error: getError(error, "Ошибка обновления сотрудника") },
            });

            throw error;
        }
    };
};

export const removeOfficeMember = (officeId, memberId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: C.REMOVE_OFFICE_MEMBER_REQUEST });

            const response = await axiosInstance.delete(`/office/${officeId}/members/${memberId}`);

            dispatch({
                type: C.REMOVE_OFFICE_MEMBER_SUCCESS,
                payload: {
                    officeId,
                    memberId,
                    userId: response.data?.userId,
                },
            });

            return response.data;
        } catch (error) {
            dispatch({
                type: C.REMOVE_OFFICE_MEMBER_FAILURE,
                payload: { error: getError(error, "Ошибка удаления сотрудника") },
            });

            throw error;
        }
    };
};

export const getMyOfficeMemberships = () => {
    return async (dispatch) => {
        try {
            dispatch({ type: C.GET_MY_OFFICE_MEMBERSHIPS_REQUEST });

            const response = await axiosInstance.get("/office-members/my");

            dispatch({
                type: C.GET_MY_OFFICE_MEMBERSHIPS_SUCCESS,
                payload: {
                    memberships: response.data?.memberships || [],
                },
            });

            return response.data;
        } catch (error) {
            dispatch({
                type: C.GET_MY_OFFICE_MEMBERSHIPS_FAILURE,
                payload: { error: getError(error, "Ошибка загрузки офисных ролей") },
            });

            return null;
        }
    };
};

export const rebuildOfficeMembers = (officeId) => {
    return async (dispatch) => {
        try {
            dispatch({ type: C.REBUILD_OFFICE_MEMBERS_REQUEST });

            const response = await axiosInstance.post(`/office/${officeId}/members/rebuild`);

            dispatch({
                type: C.REBUILD_OFFICE_MEMBERS_SUCCESS,
                payload: {
                    officeId,
                    members: response.data?.members || [],
                },
            });

            await dispatch(getOfficeMembers(officeId));

            return response.data;
        } catch (error) {
            dispatch({
                type: C.REBUILD_OFFICE_MEMBERS_FAILURE,
                payload: { error: getError(error, "Ошибка восстановления сотрудников") },
            });

            throw error;
        }
    };
};
